import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import AccountMenu from './AccountMenu';
import Button from '../../components/Button';
import Processing from '../../components/Processing';

import Api, { Utils } from '../../Api';

const dateFormat = 'MMM, Do YYYY';
const TBD = 'TBD*';

class OrderStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orderListLoading: false,
      orderList: [],
      error: null
    };
  }

  componentWillMount() {
    this.setState({ orderListLoading: true });
    Api.getOrders().then(orders => {
        this.setState({
          orderListLoading: false,
          orderList: orders
        })
      })
      .catch(error => {
        this.setState({ error: error });
        console.error(error);
      });
  }

  render() {
    let orders = (this.state.orderList ? this.state.orderList.orders : null) || [];

    let orderEntryList = null;
    if (this.state.error) {
      orderEntryList = <div>Something went wrong: <em>{this.state.error.message}</em></div>;
    } else if (this.state.orderListLoading) {
      orderEntryList = <div className="fullscreen-component center-inside"><Processing /></div>;
    } else {
      orderEntryList = orders.map((orderEntry) => {
        return (
          <div className="orderlist-container" key={`order-${orderEntry.token}`}>
            <OrderEntry
              order={orderEntry}
              products={this.state.orderList.products}
              brands={this.state.orderList.brands} />
          </div>
        );
      });
    }

    return (
      <div className="account-orders">
        <h1>Your Orders</h1>
        <div className="account-orders-preamble">
          <p className="note">We accept orders within 90 days of purchase that have not sold. Please ensure that items are unused, unwashed, and undamaged.</p>
          <div className="row first-row">
            <div className="col-50 align-top">
              <h2>Online Orders</h2>
              <p>If for any reason you wish to return an item you can do so by clicking on the ‘<strong>Create Return</strong>’ link underneath the order below.</p>
            </div>
            <div className="col-50 align-top">
              <h2>Return Address</h2>
              <p>Mail back all returns to the address below for 100% money back return.</p>
              <p className="address">INDIGO FAIR<br/>1920 Pacific Ave<br/>San Francisco CA<br/>94109</p>
            </div>
          </div>
        </div>
        <AccountMenu className={this.state.orderListLoading ? 'hidden' : ''}>
          <li className="active">Orders</li>
          <li className="hidden">Open Orders</li>
          <li className="hidden">Cancelled Orders</li>
        </AccountMenu>
        <div className={'order-count' + (orders.length <= 0 ? ' hidden' : '')}>{orders.length} Orders placed in the <strong>Past 6 months</strong></div>
        {orderEntryList}
      </div>
    );
  }
}

class OrderEntry extends React.Component {
  constructor(props) {
    super(props);

    this.toggleCollapsed = this.toggleCollapsed.bind(this);
    this.buildShipmentGroups = this.buildShipmentGroups.bind(this);

    this.state = {
      collapsed: false
    };
  }

  toggleCollapsed(event) {
    if (event.defaultPrevented) return;
    event.preventDefault();

    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  buildShipmentGroups() {
    let shipmentGroups = [];
    let shippedGoods = [];

    // Group products inside each shipment
    this.props.order.shipments.forEach(shipment => {
      // Adds every item token to the array of shipped goods. It's not a problem if there are duplicates.
      shipment.order_item_tokens.forEach(order_item_token => {
        shippedGoods.push(order_item_token);
      });

      // Create shipment group
      let shipmentGroup = {};
      shipmentGroup.shipment = shipment;
      shipmentGroup.items = this.props.order.items.filter(order_item => {
        return (shipment.order_item_tokens.indexOf(order_item.token) >= 0);
      });
      if (shipmentGroup.items.length === 0) {
        console.error('invalid shipment');
        return;
      }

      shipmentGroup.products = {};
      shipmentGroup.items.forEach(order_item => {
        shipmentGroup.products[order_item.product_token] = this.props.products[order_item.product_token];
      });

      shipmentGroup.brand_token = shipmentGroup.items[0].brand_token;
      shipmentGroup.brand = this.props.brands[shipmentGroup.brand_token];

      shipmentGroups.push(shipmentGroup);
    });

    // Group the remaining products that don't have shipment status yet
    Object.keys(this.props.brands).forEach(brand_token => {
      let items = this.props.order.items
        .filter(order_item => {
          return(order_item.brand_token === brand_token);
        })
        .filter(order_item => {
          return(shippedGoods.indexOf(order_item.token) < 0);
        });
      if (items.length <= 0) return;

      let shipmentGroup = {};
      shipmentGroup.shipment = null;
      shipmentGroup.items = items;
      shipmentGroup.products = {};
      shipmentGroup.items.forEach(order_item => {
        shipmentGroup.products[order_item.product_token] = this.props.products[order_item.product_token];
      });
      shipmentGroup.brand_token = brand_token;
      shipmentGroup.brand = this.props.brands[shipmentGroup.brand_token];

      shipmentGroups.push(shipmentGroup);
    });

    // We need this sorted by brand.
    return(
      shipmentGroups
      .sort((a, b) => {
        return(a.brand_token.localeCompare(b.brand_token));
      })
    );
  }

  render() {
    let shipments = this.buildShipmentGroups();
    let shipmentList = shipments.map(shipment => {
      return (
        <OrderShipmentGroup
          className={this.state.collapsed ? 'hidden' : ''}
          key={`order-shipment-group-${shipment.brand_token}-${shipment.shipment ? shipment.shipment.token : 'not-shipped'}`}
          shipment={shipment}
          />
      );
    });

    return (
      <div className="order-entry">
        <OrderEntryHeader
          onClick={this.toggleCollapsed}
          order={this.props.order}
          collapsed={this.state.collapsed}
          />
        {shipmentList}
      </div>
    );
  }
}

class OrderEntryHeader extends React.Component {
  render() {
    let order = this.props.order;
    if (!order) return;

    let orderCreation = moment(order.created_at);
    let addressName = order.shipping_address ? order.shipping_address.name : null;

    let freight = TBD;
    if (order.shipping_amount_cents !== undefined && order.shipping_amount_cents !== null) {
      if (order.shipping_amount_cents === 0) {
        freight = 'Free';
      } else {
        freight = '$' + Api.Utils.formatCents(order.shipping_amount_cents);
      }
    }
    let total = '$' + Api.Utils.formatCents(order.total_amount_cents);
    if (freight === TBD) {
      total += '*';
    }

    return (
      <div className="order-header" id={`order-header-${order.token}`} onClick={this.props.onClick}>
        <div className="header-block collapsed">
          {this.props.collapsed ? '+' : '-'}
        </div>
        <div className="header-block placed">
          <div className="header">Order Placed</div>
          <div className="value">{orderCreation.format(dateFormat)}</div>
        </div>
        <div className="header-block subtotal">
          <div className="header">Subtotal</div>
          <div className="value">${Api.Utils.formatCents(order.items_amount_cents)}</div>
        </div>
        <div className="header-block freight">
          <div className="header">Freight</div>
          <div className="value">{freight}</div>
        </div>
        <div className="header-block total">
          <div className="header">Total</div>
          <div className="value">{total}</div>
        </div>
        <div className={'header-block shipto' + (addressName ? '' : ' empty')}>
          <div className="header">Ship to</div>
          <div className="value">{addressName}</div>
        </div>
        <div className="header-block ordernumber">
          <div className="header">Order Number</div>
          <div className="value">{order.token}</div>
        </div>
        <div className="header-block actions hidden">
          <div className="action">Order Details</div>
          <div className="action">Invoice</div>
        </div>
      </div>
    );
  }
}

class OrderShipmentGroup extends React.Component {
  render() {
    let shipment = this.props.shipment;
    let orderItems = this.props.shipment.items.map((order_item, index) => {
      return (
        <OrderProduct
          key={`order-${shipment.token}-product-${order_item.token}`}
          hideDeliveryStatus={index>0}
          orderItem={order_item}
          product={shipment.products[order_item.product_token]}
          brand={shipment.brand}
          shipment={shipment.shipment}
        />
      );
    });

    return (
      <div className={'order-shipment-group' + (this.props.className ? ' ' + this.props.className : '')}>{orderItems}</div>
    );
  }
}

class OrderProduct extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    orderItem: PropTypes.object.isRequired,
    shipment: PropTypes.object,
    hideDeliveryStatus: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.buyItAgain = this.buyItAgain.bind(this);
  }

  buyItAgain() {
    let payload = {};
    payload.brand_token = this.props.orderItem.brand_token;
    payload.product_token = this.props.orderItem.product_token;
    payload.product_option_token = this.props.orderItem.product_option_token;
    payload.quantity = this.props.orderItem.quantity;
    payload.price_cents = this.props.orderItem.price_cents;

    return Api.addToCart([ payload ]);
  }

  render() {
    let product = this.props.product;
    let orderItem = this.props.orderItem;

    if (!product) {
      return <div>Invalid product.</div>;
    }

    let productOption = product.options.find((productOption) => {
      return (productOption.token === orderItem.product_option_token);
    });

    let productImage = null;
    let productImageUrl = null;
    if (productOption.images.length > 0) {
      productImageUrl = productOption.images[0].url;
    } else if (product.images.length > 0) {
      productImageUrl = product.images[0].url;
    }

    if (productImageUrl) {
      productImage = <img src={productImageUrl} role="presentation" />;
    }

    let deliveryStatusSection = null;
    let buttons = null;
    if (!this.props.hideDeliveryStatus) {
      let deliveryStatusHeader = orderItem.state;
      if (deliveryStatusHeader === 'WAITING_ON_SHIPPING') {
        deliveryStatusHeader = 'Shipping Soon';
      } else {
        deliveryStatusHeader = deliveryStatusHeader.replace(/_/g, ' ');
      }
      let freightValue = null;
      if (this.props.shipment && this.props.shipment.cost_cents !== null) {
        if (this.props.shipment.cost_cents === 0) {
          freightValue = <span className="price-info">Free Freight</span>;
        } else {
          freightValue = <span className="price-info">Freight <span className="price">${Api.Utils.formatCents(this.props.shipment.cost_cents)}</span></span>;
        }
      }
      if (!freightValue && orderItem.expected_ship_date) {
        freightValue = 'Expected to ship at ' + Utils.millisToYMD(orderItem.expected_ship_date);
      }

      deliveryStatusSection = 
        <div>
          <div className="header">{deliveryStatusHeader}</div>
          <div className="detail">{freightValue}</div>
        </div>;

      if (this.props.shipment && this.props.shipment.tracking_code) {
        buttons =
          <div className="actions button-column">
            <Button className="hidden default">Track Package</Button>
            <Button className="hidden">Download Invoice</Button>
            <Button className="hidden">Cancel Item</Button>
            <Button className="hidden">Return Item</Button>
            <Button className="hidden">Archive Order</Button>
            <Button className="hidden">Leave Feedback</Button>
          </div>;
      }
    }

    if (!buttons) buttons = <div className="actions button-column" />;

    return (
      <div className="product-entry" id={`order-product-entry-${this.props.orderItem.token}`}>
        <div className="delivery-status">{deliveryStatusSection}</div>
        <div className="product-info">
          <div className="product-data">
            <div className="image">{productImage}</div>
            <div className="details">
              <div className="brand-name">{this.props.brand.name}</div>
              <div className="product"><span className="quantity">{this.props.orderItem.quantity} x</span> {this.props.product.name}</div>
              <div className="individual-prices">
                <div className="wholesale price-info">Wholesale Price <span className="price">${Api.Utils.formatCents(this.props.orderItem.price_cents)}</span></div>
                <div className="retail price-info">Retail Price <span className="price">${Api.Utils.formatCents(productOption.retail_price_cents)}</span></div>
              </div>
            </div>
          </div>
          <div className="actions"><Button onClick={this.buyItAgain}>Buy it Again</Button></div>
        </div>
        {buttons}
      </div>
    );
  }
}

export default OrderStatus;
export {
  OrderEntry,
  OrderEntryHeader,
  OrderProduct
};



/** WEBPACK FOOTER **
 ** ./src/views/user/account_order_status.js
 **/